import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export interface GetChatTokenResponse {
  token: string;
  status: number;
}

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<GetChatTokenResponse, void>({
    query: () => ({
      url: 'v4/chat-firebase/auth',
      method: 'POST',
    }),
  });
